import * as React from 'react';
import { ThemeContext } from 'react-fela';
import type { GlobalTheme } from 'types';

type Props = React.SVGProps<SVGSVGElement>;

export default function EditCircleIcon(props: Props): JSX.Element {
  const { width = '100%', height = '100%', ...rest } = props;
  const theme = React.useContext(ThemeContext) as GlobalTheme | null;

  const circleFill = theme?.color?.secondaryFullBackground;
  const iconFill = theme?.color?.iconLightFill;

  return (
    <svg className="editCircle" width={width} height={height} viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <circle cx="26" cy="26" r="26" fill={circleFill}/>
      <path d="M17.8333 34.1667H19.4958L30.9 22.7625L29.2375 21.1L17.8333 32.5042V34.1667ZM16.6667 36.5C16.3361 36.5 16.059 36.3882 15.8354 36.1646C15.6118 35.941 15.5 35.6639 15.5 35.3333V32.5042C15.5 32.1931 15.5583 31.8965 15.675 31.6146C15.7917 31.3326 15.9569 31.0847 16.1708 30.8708L30.9 16.1708C31.1333 15.9569 31.391 15.7917 31.6729 15.675C31.9549 15.5583 32.2514 15.5 32.5625 15.5C32.8736 15.5 33.175 15.5583 33.4667 15.675C33.7583 15.7917 34.0111 15.9667 34.225 16.2L35.8292 17.8333C36.0625 18.0472 36.2326 18.3 36.3396 18.5917C36.4465 18.8833 36.5 19.175 36.5 19.4667C36.5 19.7778 36.4465 20.0743 36.3396 20.3562C36.2326 20.6382 36.0625 20.8958 35.8292 21.1292L21.1292 35.8292C20.9153 36.0431 20.6674 36.2083 20.3854 36.325C20.1035 36.4417 19.8069 36.5 19.4958 36.5H16.6667ZM30.0542 21.9458L29.2375 21.1L30.9 22.7625L30.0542 21.9458Z" fill={iconFill}/>
    </svg>
  );
}


